module.exports={
  "Source": "Kilde",
  "Short stories from Worlds Best News": "Kort nyt fra Verdens Bedste Nyheder"
}
